import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import { ResourcesRequest, ResourcesResponse } from "../../models/Resources.model";

const API_URL = environment.apiUrl;
export const getResources = createAsyncThunk<ResourcesResponse, ResourcesRequest>(
  "resources/getResources",
  async (requestData: ResourcesRequest, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}Resource/GetResource`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${requestData.token}`,
        },
        body: JSON.stringify({
          companyKey: requestData.companyKey,
          token: requestData.token,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: ResourcesResponse = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Failed to fetch resources",
      );
    }
  },
);
